import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { Device } from "../../../models/device";
import { applicationLogger } from "../../../logging/logger";
import { TemperatureBaseDevice } from "./temperature-base-device";
import { Store } from "aurelia-store";
import * as State from "../../../store/state";
import IState = State.IState;
import { Api } from "../../../services/api";
import { I18N } from "aurelia-i18n";


@autoinject
export class DraginoLLMS01LeafMoisture extends TemperatureBaseDevice {
	@bindable humidity;
	

	constructor(store: Store<IState>, api: Api, i18n: I18N ) {
		super(store, api, i18n);
	}

	activate(device: Device) {
		applicationLogger.debug(`${DraginoLLMS01LeafMoisture.name}.activate() called.`);
		this.device = device;

	
	}

	@computedFrom('device.data')
	get averageSoilMoisture(): number {
		return this.calculateAverageSoilMoisture();
	}


	@computedFrom('device.data')
	get maximumSoilMoisture(): number {
		return this.findMaximumSoilMoisture();
	}

	@computedFrom('device.data')
	get medianSoilMoisture(): number {
		return this.findMedianSoilMoisture();
	}

	findMedianSoilMoisture(): number {


		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		const numbers: number[] = [];
		
		if (data.soilMoisture1 != 0.0) {
			numbers.push(data.soilMoisture1);
		};

		if (data.soilMoisture2 != 0.0) {
			numbers.push(data.soilMoisture2);
		}

		if (data.soilMoisture3 != 0.0) {
			numbers.push(data.soilMoisture3);
		}

		if (data.soilMoisture4 != 0.0) {
			numbers.push(data.soilMoisture4);
		};

		if (data.soilMoisture5 != 0.0) {
			numbers.push(data.soilMoisture5);
		};

		if (data.soilMoisture6 != 0.0) {
			numbers.push(data.soilMoisture6);
		};

		// Sort the array in ascending order
		numbers.sort((a, b) => a - b);

		const length = numbers.length;
		const middle = Math.floor(length / 2);

		// Check if the array length is even or odd
		if (length % 2 === 0) {
			// If even, return the average of the two middle elements
			return (numbers[middle - 1] + numbers[middle]) / 2;
		} else {
			// If odd, return the middle element
			return numbers[middle];
		}
}

	private findMaximumSoilMoisture(): number {


		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		const numbers: number[] = [data.soilMoisture1, data.soilMoisture2, data.soilMoisture3, data.soilMoisture4, data.soilMoisture5, data.soilMoisture6];
		const max: number = Math.max(...numbers);

		return max;
	}

	private calculateAverageSoilMoisture(): number {
		if (this.device === undefined || this.device === null || this.device.data === undefined || this.device.data == null) {
			return null;
		}

		var data = this.device.data;
		var measureCount = 0;
		var soilMoisture = 0.0;

		if (data.soilMoisture1 != null && data.soilMoisture1 != 0.0) {
			soilMoisture += data.soilMoisture1;
			measureCount++;
		}

		if (data.soilMoisture2 != null && data.soilMoisture2 != 0.0) {
			soilMoisture += data.soilMoisture2;
			measureCount++;
		}
		if (data.soilMoisture3 != null && data.soilMoisture3 != 0.0) {
			soilMoisture += data.soilMoisture3;
			measureCount++;
		}
		if (data.soilMoisture4 != null && data.soilMoisture4 != 0.0) {
			soilMoisture += data.soilMoisture4;
			measureCount++;
		}
		if (data.soilMoisture5 != null && data.soilMoisture5 != 0.0) {
			soilMoisture += data.soilMoisture5;
			measureCount++;
		}
		if (data.soilMoisture6 != null && data.soilMoisture6 != 0.0) {
			soilMoisture += data.soilMoisture6;
			measureCount++;
		}


		return measureCount > 0 ?  soilMoisture/measureCount : soilMoisture;
	}

	@computedFrom('device.data')
	get averageTemperature(): number {
		return this.device != null && this.device.data != null ? (this.device.data.temperature1 + this.device.data.temperature2 + this.device.data.temperature3 + this.device.data.temperature4 + this.device.data.temperature5 + this.device.data.temperature6 + this.device.data.temperature7 + this.device.data.temperature8 + this.device.data.temperature9) / 9 : null;
	}

	attached() {
		if (this.tooltip) {
			this.tooltip.html = this.buildToolTip();
		}
	}

}